import React from "react";
import LoginView from "./LoginView.js";
import { Row } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as types from "../../reduxRelated/ActionTypes/actionTypes.js";
import { languageService } from "../../Language/language.service.js";
//import PropTypes from 'prop-types';
import { themeService } from "theme/service/activeTheme.service";
import { CommonModalStyle, ButtonStyle } from "style/basic/commonControls";
import { basicColors, retroColors, electricColors } from "../../style/basic/basicColors.js";
import microsoftLogo from "../../Microsoft-LogoNew.png";
import { versionInfo } from "../MainPage/VersionInfo.js";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        email: "",
        password: "",
      },
      captchaResponse: "",
      captchaLoaded: false,
    };
    this.InputChangeHandler = this.InputChangeHandler.bind(this);
    this.SubmitButtonHandler = this.SubmitButtonHandler.bind(this);
    this.SubmitOutlookButtonHandler = this.SubmitOutlookButtonHandler.bind(this);
    this.forgotPasswordHandle = this.forgotPasswordHandle.bind(this);
    this.showToastInfo = this.showToastInfo.bind(this);
    this.showToastError = this.showToastError.bind(this);
    this._handleKeyPress = this._handleKeyPress.bind(this);
    this.onCaptchaExpired = this.onCaptchaExpired.bind(this);
    this.onCaptchaLoad = this.onCaptchaLoad.bind(this);
    this.onCaptchaVerification = this.onCaptchaVerification.bind(this);
  }
  onCaptchaVerification(response) {
    this.setState({ captchaResponse: response });
  }
  onCaptchaExpired() {
    this.setState({ captchaResponse: "" });
  }
  onCaptchaLoad() {
    this.setState({ captchaLoaded: true });
  }
  InputChangeHandler(e) {
    let typeOfInput = e.target.name;
    let inputValueChanged = e.target.value;
    let user = this.state.user;
    let CopyOfuser = { ...user };

    if (typeOfInput === "email") {
      CopyOfuser.email = inputValueChanged;
      this.setState({
        user: CopyOfuser,
      });
    } else if (typeOfInput === "password") {
      CopyOfuser.password = inputValueChanged;
      this.setState({
        user: CopyOfuser,
      });
    }
  }

  _handleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.SubmitButtonHandler();
    }
  };
  SubmitButtonHandler() {
    //  console.log("Submit Button hit");
    //  this.showToastInfo("Submit Button Clicked!");
    /*  const  {captchaResponse,captchaLoaded} = this.state;
      if(!captchaLoaded){
          this.showToastError("reCAPTCHA Verification",new Error("You need to verify reCAPTCHA!"));
          return ;
      }
      if(captchaResponse===""){
        this.showToastError("reCAPTCHA Verification",new Error("Please click on reCAPTCHA! 'I'm not a robot"));
        return ;
      }*/
    let user = this.state.user;
    if (this.state.user.email !== "" && this.state.user.password !== "") {
      //  console.log(user);
      this.props.onLoginClick(user);
    }
  }

  async SubmitOutlookButtonHandler() {
    if ("caches" in window) {
      const cacheNames = await caches.keys();
      for (const cacheName of cacheNames) {
        await caches.delete(cacheName);
      }
    }
    window.location.href = "/api/microsoftauth/signin";
    // this.props.onOutlookLoginClick()
  }

  forgotPasswordHandle() {
    this.props.history.push("/forgotPassword");
  }

  showToastInfo(message) {
    toast.warn(message, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }

  showToastError(message, error) {
    toast.error(message + ": " + error, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }

  componentDidMount() {
    const { search, pathname } = window.location;
    const urlParams = new URLSearchParams(search);
    const microsoftGraphResponseToken = urlParams.get("msGraphResponse");
    const microsoftLoginError = urlParams.get("msLoginError");

    // this.showToastError(languageService("Retry"), "error");
    if (microsoftLoginError) {
      this.showToastError(languageService("Error"), microsoftLoginError);
    } else if (microsoftGraphResponseToken) {
      this.props.onMicrosoftLoginClick(microsoftGraphResponseToken);
    }

    let loggedInUser = localStorage.getItem("loggedInUser");
    if (loggedInUser) {
      if (JSON.parse(loggedInUser).resetPasswordOnLogin) {
        const token = localStorage.getItem("access_token");
        this.props.history.push(`/confirmreset/${token}?jwt=true`);
      } else {
        this.props.history.push("/");
        window.location.reload();
      }
    } else {
      localStorage.removeItem("access_token");
      localStorage.removeItem("loggedInUser");
      localStorage.removeItem("permissions");
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      this.props.actionType !== nextProps.actionType &&
      [types.LOGIN_SUCCESS, types.MICROSOFT_LOGIN_SUCCESS].includes(nextProps.actionType)
    ) {
      let loggedInUser = localStorage.getItem("loggedInUser");
      if (loggedInUser) {
        if (JSON.parse(loggedInUser).resetPasswordOnLogin) {
          const token = localStorage.getItem("access_token");
          this.props.history.push(`/confirmreset/${token}?jwt=true`);
        } else {
          this.props.history.push("/");
          window.location.reload();
        }
      } else {
        localStorage.removeItem("access_token");
        localStorage.removeItem("loggedInUser");
        localStorage.removeItem("permissions");
        this.showToastError(languageService("Retry"), languageService("Problem connecting to server"));
        this.props.history.push("/login");
      }
    }
    if (
      this.props.actionType !== nextProps.actionType &&
      [types.LOGIN_FAILURE, types.MICROSOFT_LOGIN_FAILURE].includes(nextProps.actionType)
    ) {
      // console.log(nextProps.errorMessage)
      // alert('sdfsdfsdfsdfsdfsdf')
      if (nextProps.errorMessage.status) {
        this.showToastError(languageService("Error"), languageService(nextProps.errorMessage.message));
      } else {
        this.showToastError(languageService("Retry"), languageService("Server is not accessible, Please retry in few seconds..."));
      }
    }
  }

  render() {
    return (
      <div className="App-container">
        <div
          className="App-login"
          style={themeService({
            default: {},
            retro: {
              borderRadius: "0",
              backgroundColor: "var(--nine)",
              width: "520px",
              height: "auto",
            },
            electric: {
              borderRadius: "0",
              backgroundColor: electricColors.nine,
              width: "520px",
              height: "auto",
            },
          })}
        >
          <Row>
            <LoginView
              isFetching={this.props.isFetching}
              onInputChange={this.InputChangeHandler}
              submitHandle={this.SubmitButtonHandler}
              inputValue={this.state.user}
              onKeyPress={this._handleKeyPress}
              clickForgotPasswordHandle={this.forgotPasswordHandle}
              loginWithOutlook={this.SubmitOutlookButtonHandler}
              recaptchaCallbacks={{
                verifyCallback: this.onCaptchaVerification,
                onloadCallback: this.onCaptchaLoad,
                expiredCallback: this.onCaptchaExpired,
              }}
            />
          </Row>
          {versionInfo.isSSOAppSetup() && (
            <Row>
              <div className="login-auth-heading">{languageService("Or Continue With:")}</div>
              <hr style={{ borderBottom: "1px solid rgb(209, 209, 209)", width: "96.5%" }}></hr>
              <div className="login-auth-container">
                <button className="login-auth-button" onClick={this.SubmitOutlookButtonHandler}>
                  <img src={microsoftLogo}></img>

                  <span>Microsoft</span>
                </button>
              </div>
            </Row>
          )}
        </div>
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/components/Login/LoginPage.js